import Logger from '../util/Logger';
import _ from 'lodash';

export const EmailError = {
  getEmails (error) {
    if (!error) {
      Logger.assert('Cannot access emails from invalid error');
    } else {
      return _.get(error, 'emails', null) || [];
    }
  },
  getMessage (error) {
    if (!error) {
      Logger.assert('Cannot access message from invalid error');
    } else {
      return _.get(error, 'error_message') || '';
    }
  }
};
